export default function formatCurrency(val) {
  if (!val) return "";

  // Remove tudo que não for número
  const onlyNumbers = val.replace(/\D/g, "");

  // Divide por 100 para considerar centavos
  const numberValue = parseFloat(onlyNumbers) / 100;

  // Formata para BRL
  return numberValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
  });
};